import Vue from 'vue'
import Partner from '../models/Shop/Partner'

// actions
export const actions = {
  async fetchPartners ({ commit }) {
    try {
      const partners = await Partner.include('stores', 'media').get()
      return partners.data
    } catch (err) {
      if (process.client) {
        Vue.notify({
          group: 'general',
          type: 'error',
          text: this.app.i18n.t('not_found')
        })
      }
    }
  }
}
